<template>
  <img class="logo" src="@/assets/logos/remax-balloon.svg" alt="">
</template>

<style scoped lang="scss">
  .logo {
    margin-bottom: 30px;
  }
</style>

<script>
  export default {
    name: 'RemaxLogo',
  };
</script>